'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = require('react');
var React__default = _interopDefault(React);
require('../typography/ErrorText/ErrorText.js');
require('../typography/LargeDarkText/LargeDarkText.js');
require('../typography/LargeEmphasizedWhiteText/LargeEmphasizedWhiteText.js');
require('../typography/MediumDarkText/MediumDarkText.js');
var MediumEmphasizedDarkText = require('../typography/MediumEmphasizedDarkText/MediumEmphasizedDarkText.js');
require('../typography/MediumText/MediumText.js');
require('../typography/MediumWhiteText/MediumWhiteText.js');
require('../typography/MiniatureLinkText/MiniatureLinkText.js');
require('../typography/SmallDarkText/SmallDarkText.js');
require('../typography/SmallDarkTextHeavy/SmallDarkTextHeavy.js');
require('../typography/SmallDisabledText/SmallDisabledText.js');
require('../typography/SmallEmphasizedDarkText/SmallEmphasizedDarkText.js');
require('../typography/SmallEmphasizedDisabledText/SmallEmphasizedDisabledText.js');
require('../typography/SmallEmphasizedLinkText/SmallEmphasizedLinkText.js');
require('../typography/SmallLinkText/SmallLinkText.js');
require('../typography/SmallTitleText/SmallTitleText.js');
require('../typography/SmallWhiteText/SmallWhiteText.js');
require('../typography/TinyDarkText/TinyDarkText.js');
require('../typography/TinyEmphasizedDarkText/TinyEmphasizedDarkText.js');
require('../typography/TinyLinkText/TinyLinkText.js');
require('../typography/TinyTitleText/TinyTitleText.js');
require('../typography/XXLargeDarkText/XXLargeDarkText.js');
var Divider = _interopDefault(require('@material-ui/core/Divider'));
var styledComponents = require('./styled-components.js');

var BackgroundSection = function (props) {
    var children = props.children, _a = props.divider, divider = _a === void 0 ? false : _a, _b = props.title, title = _b === void 0 ? '' : _b, _c = props.className, className = _c === void 0 ? '' : _c, _d = props.dividerMargin, dividerMargin = _d === void 0 ? '0 0 1.5rem 0' : _d;
    return (React__default.createElement(styledComponents.ColoredDiv, { className: className },
        divider && React__default.createElement(Divider, { "data-testid": 'divider', style: { margin: dividerMargin } }),
        title && (React__default.createElement(MediumEmphasizedDarkText, { component: 'h3', "data-testid": 'title', style: { marginBottom: '1rem' } }, title)),
        children));
};

module.exports = BackgroundSection;
